import {ReCaptcha} from "Core/ReCaptcha";
import * as $ from "jquery";
import {$body} from "Core/Body";

function initReCaptcha(recaptchaElementSelector) {
    let recaptchaElementLastId = undefined;
    let $element;
    
    if(typeof recaptchaElementSelector == 'string') {
        $element = $(recaptchaElementSelector);
        recaptchaElementLastId = $element.attr('id');
    }
    else if (recaptchaElementSelector instanceof $ || recaptchaElementSelector.jquery) {
        // Handle jQuery object
        $element = recaptchaElementSelector;
        recaptchaElementLastId = $element.attr('id');
    }
    else {
        $element = $('#g-recaptcha');
        recaptchaElementLastId = 'g-recaptcha';
    }

    if(typeof recaptchaElementLastId == 'undefined') {
        recaptchaElementLastId = 'g-recaptcha';
    }

    let recaptcha = new ReCaptcha();
    let sitekey = $element.attr('data-sitekey');
    setTimeout(function () {
        $body.ready(() => {
            recaptcha.render(sitekey, recaptchaElementLastId)
        })
    }, 1500);
}

export {initReCaptcha}
import {ReCaptcha} from "Core/ReCaptcha";
import * as $ from "jquery";
import {$body} from "Core/Body";

function initReCaptcha(recaptchaElementSelector) {
    let recaptchaElementLastId = undefined;
    let $element;
    
    if(typeof recaptchaElementSelector == 'string') {
        $element = $(recaptchaElementSelector);
        recaptchaElementLastId = $element.attr('id');
    }
    else if (recaptchaElementSelector instanceof $ || recaptchaElementSelector.jquery) {
        // Handle jQuery object
        $element = recaptchaElementSelector;
        recaptchaElementLastId = $element.attr('id');
    }
    else {
        $element = $('#g-recaptcha');
        recaptchaElementLastId = 'g-recaptcha';
    }

    if(typeof recaptchaElementLastId == 'undefined') {
        recaptchaElementLastId = 'g-recaptcha';
    }

    let recaptcha = new ReCaptcha();
    let sitekey = $element.attr('data-sitekey');
    setTimeout(function () {
        $body.ready(() => {
            recaptcha.render(sitekey, recaptchaElementLastId)
        })
    }, 1500);
}

export {initReCaptcha}
